import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1E4D] flex items-center justify-center px-5 hero-grid">
      <div className="w-full max-w-md">
        <button onClick={() => navigate("/")} className="flex items-center gap-2 text-slate-300 hover:text-white text-sm mb-6 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Retour au site
        </button>
        <div className="bg-white rounded-2xl shadow-2xl border border-slate-200 p-8" data-testid="admin-login-card">
          <Logo flagClass="h-9" textClass="text-2xl" />
          <h1 className="font-display mt-6 text-2xl font-bold text-slate-900">Espace Back-Office</h1>
          <p className="text-sm text-slate-500 mt-1">Accès restreint au personnel autorisé</p>

          <form onSubmit={submit} className="mt-6 space-y-4" autoComplete="off">
            <div>
              <Label className="text-slate-700 font-medium">Email</Label>
              <Input className="mt-1.5" type="email" name="bc-admin-email" placeholder="Votre adresse email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off" data-testid="admin-email-input" />
            </div>
            <div>
              <Label className="text-slate-700 font-medium">Mot de passe</Label>
              <Input className="mt-1.5" type="password" name="bc-admin-password" placeholder="Votre mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" data-testid="admin-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[#0B1E4D] hover:bg-[#0a1840] font-semibold" data-testid="admin-login-button">
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4 mr-2" /> Se connecter</>}
            </Button>
          </form>
          <button
            type="button"
            onClick={() => navigate("/admin/forgot-password")}
            data-testid="forgot-password-link"
            className="mt-4 w-full text-center text-sm text-blue-600 hover:text-blue-700 hover:underline font-medium"
          >
            Première connexion / mot de passe oublié ?
          </button>
        </div>
      </div>
    </div>
  );
}
